import { Stack } from '@mui/material';

import useStyles from '@/pages/Administration/AdministrationGeneral/AdministrationGeneral.styles';

const ParanoidTicketTemplate = () => {
  const { classes } = useStyles();

  return (
    <Stack className={classes.newTicketTemplate}>
      <div>
        Log into the portal at{' '}
        <a
          className={classes.linkText}
          target="_blank"
          rel="noreferrer"
          href="https://scope.pondurance.com/"
        >
          scope.pondurance.com
        </a>{' '}
        for details.
      </div>
    </Stack>
  );
};

export default ParanoidTicketTemplate;
